import "./assets/styles/global.css";
import "./assets/styles/global.scss";
export { default as wrapRootElement } from "./src/store/ReduxWrapper";

// Scroll position is restored on refresh and on browser back/forward (Gatsby keeps it in sessionStorage);
// we only jump to the top when the visitor follows a link to a new page.
let isHistoryNavigation = false;
if (typeof window !== "undefined") {
  window.addEventListener("popstate", () => {
    isHistoryNavigation = true;
  });
}

export function onRouteUpdate({ location, prevLocation }) {
  // meta pixel update for tracking PageView only and to resolve the 'no currency' issue
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", "PageView");
  }

  if (process.env.NODE_ENV === "production") {
    window.dataLayer = window.dataLayer || [];
    setTimeout(() => {
      window.dataLayer.push({ event: "gatsby-route-change" });
    }, 50);
  }

  const isRestore = isHistoryNavigation || !prevLocation;
  isHistoryNavigation = false;
  if (isRestore) {
    // html has scroll-behavior: smooth; restoring the saved position must be instant, not an animation
    document.documentElement.style.scrollBehavior = "auto";
    setTimeout(() => {
      document.documentElement.style.scrollBehavior = "";
    }, 1500);
  } else {
    setTimeout(() => {
      if (window.location.hash === "") window.scrollTo(0, 0);
    }, 100);
  }

  //regex for page and filters
  // const regexTemplateUprazhnenia = /^\?page=\d+(?<!0)(?:&filters=[^&]*)?$/;

  //check if search param is in format ?page=<number > 0>
  // const regexTemplateBlog = /^\?page=\d+(?<!0)$/;

  // //blog
  // if (
  //   window.location.pathname === "/blog/" &&
  //   !regexTemplateBlog.test(window.location.search)
  // ) {
  //   window.location.search = "?page=1";
  // }

  // //uprazhnenia
  // if (
  //   window.location.pathname === "/uprazhnenia/" &&
  //   !regexTemplateBlog.test(window.location.search)
  // ) {
  //   window.location.search = "?page=1";
  // }
}
